var React = require('react');

function SomeFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2483 17.5153V26.6666H18.3522V17.5153H22.0814L22.6661 13.7679H18.3522V11.7195C18.3522 10.1631 18.866 8.78126 20.338 8.78126H22.7033V5.51029C22.2879 5.45563 21.409 5.33325 19.7485 5.33325C16.281 5.33325 14.2483 7.14518 14.2483 11.274V13.7679H10.6836V17.5153H14.2483Z","fill":"white"}));
}

SomeFacebook.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = SomeFacebook;

SomeFacebook.default = SomeFacebook;
